import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ListSelectCoursesDashboard = ({ value, courses, onClick }) => (
  <ul className="list-select">
    {courses.map(course => (
      <li key={course.name} onClick={() => onClick(course)} className={`d-flex justify-content-between align-items-center ${value === course && 'active'}`}>
        <span>{course.name}</span> <FontAwesomeIcon icon="chevron-right" />
      </li>
    ))}
  </ul>
);

ListSelectCoursesDashboard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object]),
  courses: PropTypes.arrayOf(PropTypes.object),
  onClick: PropTypes.func,
};

ListSelectCoursesDashboard.defaultProps = {
  courses: [],
  value: undefined,
  onClick: () => undefined,
};

export default ListSelectCoursesDashboard;
